import { Badge, Text } from '@billy/design-system'
import React, { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import { CellProps } from 'react-table'

import { ChartOfAccountsAccount } from '../../types'

type AccountNameCellProps = CellProps<ChartOfAccountsAccount>

export const AccountNameCell = ({ data, row }: AccountNameCellProps): ReactElement => {
  const { t } = useTranslation()
  const { description, isArchived, isPaymentEnabled, name, systemRole } = data[row.id]

  return (
    <>
      <Text colorVariant={isArchived ? 'secondary' : 'primary'}>
        {`${name} `}{' '}
        {isPaymentEnabled && (
          <Badge color="accent" mode="subtle">
            {t('coa.payment_enabled')}
          </Badge>
        )}{' '}
        {!!systemRole && (
          <Badge color="neutral" mode="subtle">
            {t('coa.system_account')}
          </Badge>
        )}{' '}
        {isArchived && (
          <Badge color="warning" mode="subtle">
            {t('coa.account_archived')}
          </Badge>
        )}
      </Text>
      <Text variant="bodySM" colorVariant="secondary">
        {description}
      </Text>
    </>
  )
}
